import { Component, Input } from "@angular/core";

@Component({
  selector: "static-card",
  templateUrl: "static-card.component.html",
})
export class StaticCardComponent {
  @Input()
  headerTitle: string = "";

  @Input()
  fullWidthHeader: boolean = true;
}



// WEBPACK FOOTER //
// ./src/components/static-card/static-card.component.ts